import React from 'react';
import Barcode from 'react-barcode';
import { Card, CardTitle, CardText, CardMedia } from 'material-ui/Card';
import { Row, Col, Panel, PanelGroup, Button, FlexboxGrid, Tree, Container, Sidebar, Header, Footer, Content } from 'rsuite';

const parentStyles = {
    position: 'relative',
    // width: '500px', height: '750px',
};




export default class CaseContents extends React.Component {
    render() {
        const { product, barcode, content } = this.props;

        return (

            <div id="div-svg" style={{ display: 'flex'}}>


                <div style={parentStyles}>

                    <strong>Case: {barcode}</strong>
                    <br />
                    <br />
                    <strong>Contents:</strong>
                    
                    <br />

                    {content.map(item => (
                        <div style={{ outline: 'inset', marginBottom: '5px', marginRight: '40px' }}>

                            <strong>Unit:</strong> {item.SKU} (Qty: {item.UnitsInWhse}) <br />
                            -  Unit Lot: {item.LotCode}<br />
                            -  Unit Serial: {item.SerialNumber}<br />

                            <br />


                        </div>


                    ))}

                </div>


            </div>


        );
    }
}

